import CoreBase from '../../../../../services/engines/CoreBase';
import iframeController from '../IframeController';
import entryUpdater from '../EntryUpdater';

class RemoveHandler extends CoreBase {
    _name = 'RemoveHandler';

    /**
     * Handles jerny:remove — removes an entry from body.userInput by ems and persists.
     * @param {MessageEvent} e
     * @param {HTMLIFrameElement} iframe
     * @param {object} entry
     */
    handle = (e, iframe, entry) => {
        try {
            if (e.source !== iframe?.contentWindow) return;

            const ems = e.data?.ems;
            if (!ems || typeof ems !== 'number') return;

            const body = iframeController.parseBody(entry);
            if (!body) return;

            if (!Array.isArray(body.userInput)) return;
            body.userInput = body.userInput.filter(i => i.ems !== ems);

            entryUpdater.update(entry, body);
        } catch (error) {
            this.logError('handle', error.message);
        }
    };
}

const removeHandler = new RemoveHandler();
export default removeHandler;
